import { render } from "./GlobalSearch.vue?vue&type=template&id=3204c074&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import "./GlobalSearch.vue?vue&type=style&index=0&id=3204c074&scoped=true&lang=scss"
import "./GlobalSearch.vue?vue&type=style&index=1&id=3204c074&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3204c074"]])

export default __exports__